export default __webpack_public_path__ + "static/media/shuxin.31019639.png";